import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();

  return (
    <header className="bg-transparent border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <Link
              to="/"
              className="font-display text-2xl sm:text-3xl font-medium text-ink hover:text-accent transition-colors duration-200"
            >
              Sportschutterslicentie
            </Link>
          </div>
          <nav>
            <ul className="flex space-x-6">
              <li>
                <Link
                  to="/"
                  className={`font-body text-xs sm:text-sm uppercase tracking-wide text-ink-light hover:text-accent transition-colors duration-200 ${
                    location.pathname === '/' ? 'text-ink font-semibold' : ''
                  }`}
                >
                  Home
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;